import { useRateCardStore } from "@/stores/RateCardStore";

export const RateCardStores = [useRateCardStore];

export const RateCardChannel = {
  received(payload) {
    if (payload.id === this.rateCardStore.previewTaskId) {
      this.rateCardStore.loadingPreview = false;
      if (payload.data?.ratings) {
        this.rateCardStore.previewDemoType = payload.data.ratings[0].demo_type;
      }
      this.rateCardStore.preview = payload.data;
      this.rateCardStore.previewTaskId = undefined;
    }
    if (payload.id === this.rateCardStore.callsignTaskId) {
      this.rateCardStore.loadingCallsigns = false;
      this.rateCardStore.callsigns = payload.data;
      this.rateCardStore.callsignTaskId = undefined;
    }
    if (payload.id === this.rateCardStore.uploadTaskId) {
      this.rateCardStore.uploading = false;
      if (payload.status === "error") {
        this.rateCardStore.uploadError = payload.message;
      } else {
        this.rateCardStore.inputRateCardId = payload.data.id;
      }
      this.rateCardStore.uploadTaskId = undefined;
    }
  },
};
